import { useAppContext } from "../../../../2_ksbHub/context/appContext";

import { useBszPlannerContext } from "../../context/bszPlannerContext";

import PlannerClassesDialog from "./PlannerClassesDialog";
import PlannerClassesAdminDialog from "./PlannerClassesAdminDialog";
import PlannerProjectDialog from "./PlannerProjectDialog";

export default function BSZPlannerDialogs({ dialogs, actions }) {
  const { isATeacher } = useAppContext();

  const {
    isBszAdmin,

    showClassesDialog,
    setShowClassesDialog,

    showClassesAdminDialog,
    setShowClassesAdminDialog,
  } = useBszPlannerContext();

  return (
    <>
      {isATeacher && (
        <PlannerProjectDialog
          open={dialogs.projectDialogOpen}
          onClose={dialogs.closeProjectDialog}
          project={dialogs.editingProject}
          subjectName={dialogs.selectedSubject}
          week={dialogs.selectedWeek}
          selectedClass={dialogs.selectedClass}
          onSave={actions.handleSaveProject}
          onDelete={actions.handleDeleteProject}
        />
      )}

      <PlannerClassesDialog
        open={showClassesDialog}
        onClose={() => setShowClassesDialog(false)}
      />

      {isBszAdmin && (
        <PlannerClassesAdminDialog
          open={showClassesAdminDialog}
          onClose={() => setShowClassesAdminDialog(false)}
        />
      )}
    </>
  );
}
